import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ListSidebar from './ListSidebar';
import SingleRideSidebar from './SingleRideSidebar';
import Display from '../../Display';
import { SidebarFooter } from '../SidebarFooter/index';
import { NoRides } from '../../NoRides';

class RidesSidebar extends Component {
  render() {
    const { noRidesEver, currentJourney } = this.props;
    const isListSidebarShown = currentJourney === null && !noRidesEver;
    const isSingleRideSidebarShown = !isListSidebarShown && !noRidesEver;
    return (
      <div>
        <Display isShown={noRidesEver}>
          <div
            className="aside"
            style={{ paddingBottom: '60px', paddingTop: '0' }}
          >
            <NoRides />
            <SidebarFooter />
          </div>
        </Display>
        <ListSidebar isShown={isListSidebarShown} />
        <Display isShown={isSingleRideSidebarShown}>
          <SingleRideSidebar />
        </Display>
      </div>
    );
  }
}

RidesSidebar.propTypes = {
  noRidesEver: PropTypes.bool,
  currentJourney: PropTypes.object,
};

export default connect(
  state => ({
    noRidesEver: !(
      !state.rides.areJourneysEverLoaded || state.rides.areJourneysEverExist
    ),
    currentJourney: state.rides.currentJourney,
  }),
  () => ({}),
)(RidesSidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/RidesSidebar/index.js